<template>
  <AppAdSense
    v-if="!subscriptionStore.isPaidUser"
    ad-class="adsense adsense--top"
    ad-style="display:block"
    ad-client="ca-pub-9118328092882671"
    ad-slot="6454082920"
  />
</template>

<script setup lang="ts">
  import { useSubscriptionStore } from '$/stores/subscription'

  const subscriptionStore = useSubscriptionStore()
</script>

<style lang="sass" scoped>
  .adsense--top
    text-align: center
    margin: auto
    height: 120px
    width: 100%
    @media(min-width: 640px)
      width: 620px
    @media(min-width: 860px)
      width: 760px
</style>
